

































































import { Component, mixins } from '@niknevis/vue-modules'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import Radio from '@/modules/shared/components/shared/kit/Radio.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import { ProfitRequest } from '@/modules/profit/models/profit-request.model'
import { ProfitType } from '@/modules/profit/models/profit-resource.model'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {
    BaseButton,
    BaseInput,
    Radio,
    CurrencyInput,
    BaseCard,
    Modal
  }
})
export default class AdminProfitBaseDialog extends mixins<DialogMixin>(DialogMixin) {
  @Prop({ default: '' }) header: string
  @Prop({ required: true }) profitTypesInPersian: { [key in ProfitType]: string }
  @Prop({ default: 'ثبت' }) submitButtonLabel: string
  @Prop({ default: 'q-px-xl' }) submitButtonClasses: string
  @Prop() submitButtonIcon: string

  private dialogVisibility = false

  protected requestData: ProfitRequest = {
    amount: null,
    type: ProfitType.INCREASE,
    description: null
  }

  protected profitTypes = [
    { label: this.profitTypesInPersian[ProfitType.INCREASE], value: ProfitType.INCREASE },
    { label: this.profitTypesInPersian[ProfitType.DECREASE], value: ProfitType.DECREASE }
  ]

  protected get isLoading() {
    return false
  }

  private setValue(key, value) {
    this.$set(this.requestData, key, value)
  }

  protected onSubmit() {
  }
}
